export const createAcceptUserChallengeRequest = (challengeId) => {
  return {
    url: `/user_challenges/${challengeId}/accept`,
    method: "POST",
  };
};

export const createRejectUserChallengeRequest = (challengeId) => {
  return {
    url: `/user_challenges/${challengeId}/reject`,
    method: "POST",
  };
};

export const createGetUserChallengesRequest = () => {
  return {
    url: "/user_challenges",
    method: "GET",
  };
};

export const createGetUserChallengeDetailsRequest = (challengeId) => {
  return {
    url: `/user_challenges/${challengeId}`,
    method: "GET",
  };
};

export const createGetUserChallengeParticipantDetailsRequest = (challengeId, participantId) => {
  return {
    url: `/user_challenges/${challengeId}/participants/${participantId}`,
    method: "GET",
  };
};
